import { render, staticRenderFns } from "./MetadataGroups.vue?vue&type=template&id=5dc8b80f"
import script from "./MetadataGroups.vue?vue&type=script&lang=js"
export * from "./MetadataGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports